import React, { useState } from 'react';

import CheckAvailabilityMenu from './CheckAvailabilityMenu';
import CheckAvailabilityDates from './CheckAvailabilityDates';
import {
  CheckAvailabilityContext,
  CheckAvailabilityContextShape,
} from '../context';
import CheckAvailabilityQuantity from './CheckAvailabilityQuantity';
import CheckAvailabilityProductComponent from './CheckAvailabilityProduct';
import { ErrorBoundary } from './ErrorBoundary';
import { ErrorMessage } from './styled-components';

type Props = {
  /** Function to scroll to bottom of the screen.
   *
   * We need to scroll when check availability is shown */
  scrollToBottom: () => any;
};

const CheckAvailability: React.FC<Props> = ({ scrollToBottom }) => {
  const [changingDates, setChangingDates] = useState(false);
  const [changingProduct, setChangingProduct] = useState(false);
  const [changingQuantity, setChangingQuantity] = useState(false);
  const [headerErrorMessage, setHeaderErrorMessage] = useState('');

  const value: CheckAvailabilityContextShape = {
    changingDates,
    changingProduct,
    changingQuantity,
    headerErrorMessage,
    setChangingDates,
    setChangingProduct,
    setChangingQuantity,
    setHeaderErrorMessage,
  };

  return (
    <CheckAvailabilityContext.Provider value={value}>
      <ErrorBoundary
        errorUI={
          <ErrorMessage>Error occurred when checking availability</ErrorMessage>
        }
      >
        <CheckAvailabilityMenu scrollToBottom={scrollToBottom} />
        <CheckAvailabilityDates />
        <CheckAvailabilityQuantity />
        <CheckAvailabilityProductComponent />
      </ErrorBoundary>
    </CheckAvailabilityContext.Provider>
  );
};

export default CheckAvailability;
